import { Link } from 'react-router-dom';
import './TicketingPopup.css';

type IProps = {
  onChange: () => void;
};
function TicketingPopup({ onChange }: IProps) {
  return (
    <div className='app-container'>
      <div className='ticket-container'>
        <div className='ticket-header'>
          <div className='ticket-icon'>🎫</div>
          <h2 className='ticket-title'>Collect your Ticket</h2>
          <p className='ticket-description'>
            Your ticket is ready! Please review the details below and collect it
          </p>
        </div>
        <div className='ticket-card'>
          <>
            <img
              src='https://m360ict.s3.ap-south-1.amazonaws.com/toab-bttf/logo/bttf.webp'
              alt='https://m360ict.s3.ap-south-1.amazonaws.com/toab-bttf/logo/bttf.webp'
              style={{
                objectFit: 'contain',
                maxWidth: '572px',
                width: '100%',
              }}
            />

            <div className='ticket-details'>
              <div className='detail-item'>
                <span className='detail-icon'>📅</span>
                <span className='detail-text'>{'30 OCT - 01 NOV 2025'}</span>
              </div>
              <div className='detail-item'>
                <span className='detail-icon'>🕐</span>
                <span className='detail-text'>
                  {'Open at 10:00 AM - 8:00 PM'}
                </span>
              </div>
              <div className='detail-item'>
                <span className='detail-icon'>📍</span>
                <span className='detail-text'>
                  {
                    'Bangladesh-China Friendship Conference Center (BCFCC) Agargaon, Sher-E-Bangla Nagar, Dhaka-1207'
                  }
                </span>
              </div>
            </div>
          </>
        </div>
        <Link
          to={'/visitor/ticketing-request?isTicketing=available'}
          className='text-decoration-none'
          onClick={() => onChange()}
        >
          <div className='ticket-actions'>
            <button className='cancel-button'>Collect Ticket</button>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default TicketingPopup;
